export default "__VITE_ASSET__db1f5735__"